import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {fadeInOut} from '../../animations/animations';
import {CheckPinValidity} from '../../states/profile/profile.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {Select, Store} from '@ngxs/store';
import {ProfileState} from '../../states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';

@Component({
  selector: 'app-lock-screen-dialog',
  templateUrl: './lock-screen-dialog.component.html',
  styleUrls: ['./lock-screen-dialog.component.scss'],
  animations: [fadeInOut],
})
export class LockScreenDialogComponent {
  @Input() show: boolean;
  @Input() focusPin: boolean;

  @Output() pinComplete: EventEmitter<boolean> = new EventEmitter();
  @Output() forgotPin: EventEmitter<void> = new EventEmitter();

  isInvalid: boolean;
  isDisabled: boolean;

  pinValue: string;

  @Select(ProfileState.success) success$: Observable<boolean>;

  @ViewChild('lockScreenPin') lockScreenPin;

  constructor(private store: Store) {
  }

  codeComplete(pin: string): void {
    if (pin) {
      this.pinValue = pin;
      this.isDisabled = true;
      this.isInvalid = false;

      this.store.dispatch(new CheckPinValidity(pin))
        .pipe(take(1), withLatestFrom(this.success$))
        .subscribe(([_, success]) => {
          this.isInvalid = !success;
          this.isDisabled = false;
          this.pinComplete.emit(success);
          setTimeout(() => this.pinValue = '', 200);
          if (success) {
            window.location.reload();
          }
        });
    }
  }

}
